import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import {
  SUBCONTRACTORS_RECORDS_VIEW,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
} from 'scenes/Permissions/constants/permissions';
import { selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { calendarOpenPreviousWeek } from '../actions/demoActions';
import { selectIsPersonalWorkCalendarMode } from '../selectors/base-work-calendar.selectors';
import {
  selectFetchedWeekNumbers,
  selectWorkSearchParamsVisibleWeeks,
} from '../selectors/workSearchParamsSelectors';
import { loadAdminCalendarFilesDataInTimeframe } from './loadAdminCalendarFilesDataInTimeframe.thunk';
import { loadAdminCalendarRecordsDataInTimeframe } from './loadAdminCalendarRecordsDataInTimeframe.thunk';
import { loadCalendarDataInTimeframe } from './loadCalendarDataInTimeframe.thunk';
import { loadSubcontractorRecordsData } from './loadSubcontractorRecordsData.thunk';
import { loadWorkCalendarWorkTimeSaldoInformationInTimeframe } from './loadWorkCalendarWorkTimeSaldoInformationInTimeframe.thunk';
import { loadPersonalWorkCalendarData } from './my-lixani/loadPersonalWorkCalendarData.thunk';

export const setOpenPreviousWeek = createAsyncThunk(
  'workCalendar/setOpenPreviousWeek',
  async (_, { dispatch, getState }) => {
    const state = getState();

    const isPermissionFromActiveEmployerToViewAllBusinessRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS
      );
    const visibleWeeks = selectWorkSearchParamsVisibleWeeks(state);

    const fetchedWeeks = selectFetchedWeekNumbers(state);

    const isPersonalWorkCalendarMode = selectIsPersonalWorkCalendarMode(state);

    const isPermissionFromActiveBusinessToViewSubcontractorRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        SUBCONTRACTORS_RECORDS_VIEW
      );

    const selectedProject = selectSelectedProject(getState());

    const activeEmployerBusinessId =
      selectUserActiveEmployerBusinessId(getState());

    const weekISO =
      visibleWeeks.length > 0
        ? visibleWeeks[0]
        : dayjs().startOf('isoWeek').format();

    const prevWeek = dayjs(weekISO).subtract(1, 'week').format();

    const prevWeekNumber = dayjs(prevWeek)
      .endOf('isoWeek')
      .format('GGGG[W]WW')
      .split('W')[1];

    dispatch(calendarOpenPreviousWeek(prevWeek));

    if (!fetchedWeeks.includes(prevWeekNumber)) {
      dispatch(loadWorkCalendarWorkTimeSaldoInformationInTimeframe());

      if (isPersonalWorkCalendarMode) {
        await dispatch(loadPersonalWorkCalendarData());
      } else if (
        isPermissionFromActiveEmployerToViewAllBusinessRecords &&
        activeEmployerBusinessId === selectedProject.business_id
      ) {
        await Promise.allSettled([
          dispatch(loadAdminCalendarRecordsDataInTimeframe()),
          dispatch(loadAdminCalendarFilesDataInTimeframe()),
        ]);
      } else {
        if (isPermissionFromActiveBusinessToViewSubcontractorRecords) {
          await Promise.allSettled([
            dispatch(loadSubcontractorRecordsData()),
            dispatch(loadCalendarDataInTimeframe()),
          ]);
        } else {
          await dispatch(loadCalendarDataInTimeframe());
        }
      }
    }
  }
);
